import { useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getPasswordResetToken } from "../services/operations/authAPI";
import { RxCountdownTimer } from "react-icons/rx";
import Spinner from "./Spinner";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  const [isDisabled, setIsDisabled] = useState(false);
  const [time, setTime] = useState(60);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    dispatch(getPasswordResetToken(email, setEmailSent));
    
    let timer = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);

    setTimeout(() => {
      setIsDisabled(false);
      clearInterval(timer);
      setTime(60); // Reset the timer
    }, 60000);
  }

  return (
    <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
      {loading ? (
        <Spinner/>
      ) : (
        <div className="max-w-[500px] p-4 lg:p-8 border-2 border-black rounded-lg">
          <h1 className="text-[1.875rem] font-semibold leading-[2.375rem]">
            {!emailSent ? "Reset your password" : "Check email"}
          </h1>
          <p className="my-4 text-[1.125rem] leading-[1.625rem]">
            {!emailSent
              ? "Have no fear. We'll email you instructions to reset your password. If you dont have access to your email we can try account recovery"
              : `We have sent the reset email to ${email}`}
          </p>
          <form onSubmit={handleOnSubmit}>
            {!emailSent && (
              <label className="w-full">
                <p className="mb-1 text-[0.875rem] leading-[1.375rem]">
                  Email Address <sup className="text-pink-200">*</sup>
                </p>
                <input
                  required
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email address"
                  className="form-style w-full p-2 border-[1px] border-black rounded-lg"
                />
              </label>
            )}
            <button
              type="submit"
              className="mt-6 w-full rounded-[8px] bg-yellow-400 hover:bg-yellow-500 active:bg-yellow-600 py-[12px] px-[12px] font-medium"
              disabled={isDisabled && emailSent}
            >
              {!emailSent ? "Submit" : "Resend Email"}
            </button>
          </form>

          <div className="mt-6 flex items-center justify-between">
            <Link to="/login">
              <p className="flex items-center gap-x-2">
                <BiArrowBack /> Back To Login
              </p>
            </Link>

            {
              emailSent && isDisabled && (
              <div className="text-blue-600 flex items-center gap-x-2">
                <RxCountdownTimer/> 
                <p className="text-end">{`Resend mail in ${time}`}</p>
              </div>
              )
            }
          </div>
        </div>
      )}
    </div>
  )
}

export default ForgotPassword